import { PropsWithChildren } from "react";

import { Link } from "@chakra-ui/next-js";
import { Box, Container, Flex, Grid, SimpleGrid, Text, Button } from "@chakra-ui/react";

import { Product } from "@/__generated__/graphql";
import Logo from "@/components/shared/Logo";
import { pathTo } from "@/utils/pathGenerators";

function PricingLayout({ children }: PropsWithChildren) {
  return (
    <Box
      sx={{
        backgroundColor: "rgb(17 24 39)",
        minHeight: "100vh",
        color: "white",
      }}
    >
      <SimpleGrid height="100vh" overflowX="hidden" spacing={0}>
        <Grid gridTemplateColumns={"1fr"} gridTemplateRows={"auto 1fr auto"} overflowX="hidden" w="100%">
          <Flex
            align="center"
            borderBottom="1px solid"
            borderColor="whiteAlpha.100"
            flexDirection={{ base: "row", sm: "row" }}
            justify="space-between"
            p={{ base: 2, sm: 3, md: 4 }}
            pb={{ base: 2, sm: 3, md: 4 }}
          >
            <Box flex="0 1 auto">
              <Logo color="white" h={{ base: "24px", sm: "33px" }} product={Product.Release} />
            </Box>

            <Box flex="0 0 auto">
              <Link href={pathTo("/login")} style={{ marginRight: "8px" }}>
                <Button
                  _hover={{
                    bg: "whiteAlpha.100",
                    borderColor: "white",
                  }}
                  bg="transparent"
                  borderColor="whiteAlpha.400"
                  color="white"
                  size={{ base: "xs", sm: "sm" }}
                  variant="outline"
                >
                  Login
                </Button>
              </Link>
              <Link isExternal href="https://release.com/book-a-demo">
                <Button colorScheme="niagara" size={{ base: "xs", sm: "sm" }}>
                  Book Demo
                </Button>
              </Link>
            </Box>
          </Flex>

          <Box overflowX="hidden" overflowY="auto">
            {children}
          </Box>

          <Container maxW="md" p={{ base: 3, sm: 4 }} textAlign="center">
            <Text color="gray.400" fontSize="sm">
              Have questions? Contact us at{" "}
              <Link color="plum.500" fontWeight="medium" href="mailto:support@release.com">
                support@release.com
              </Link>
            </Text>
          </Container>
        </Grid>
      </SimpleGrid>
    </Box>
  );
}

export default PricingLayout;
